import propType from 'prop-types';
import React from 'react';

const Banner = ({ title }) => (
  <div className="banner__wrapper">
    <div className="banner__content">
      <header className="banner__description">
        <h1 className="banner__title">{title}</h1>
        <p className="banner__sub-title">
          Stay up to date with our most recent news and updates
        </p>
      </header>
    </div>
  </div>
);

Banner.propTypes = {
  title: propType.string.isRequired
};

export default Banner;
